import { getTableConversationRelation } from 'owa-mail-list-store';
/**
 * Filter the conversationRowKeys by existence and isRead value
 * @param conversationRowKeys the conversation rowKeys to filter for
 * @param tableViewId the id of table
 * @param isReadValue to set
 * @return the filtered conversation rowKeys
 */
export default function filterConversationsByIsReadValue(conversationRowKeys, tableViewId, isReadValue) {
    var rowKeysToUpdate = [];
    conversationRowKeys.forEach(function (rowKey) {
        var tableViewConversationRelation = getTableConversationRelation(rowKey, tableViewId);
        if (tableViewConversationRelation &&
            tableViewConversationRelation.unreadCount > 0 === isReadValue) {
            rowKeysToUpdate.push(rowKey);
        }
    });
    return rowKeysToUpdate;
}
//# sourceMappingURL=filterConversationsByIsReadValue.js.map